import type { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
  fetchSubscriptionSeatsByAdvisorIdRequest,
  postSubscriptionSeatByAdvisorIdResponse,
  deleteSubscriptionSeatByAdvisorIdResponse,
  postSeatInvitationByAdvisorIdResponse,
  postDirectAssignSeatByAdvisorIdResponse,
  postUpdateSubscriptionSeatResponse,
} from './subscriptionSeatsModel';
import { AppState } from './store';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import { isNullOrUndefined } from '@shared/isNullOrUndefined';

/**
 * Middleware to invalidate & refetch subscription seats data when mutations complete
 */
function invalidateSubscriptionSeatsMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (
    action.type === postSubscriptionSeatByAdvisorIdResponse.type ||
    action.type === deleteSubscriptionSeatByAdvisorIdResponse.type ||
    action.type === postSeatInvitationByAdvisorIdResponse.type ||
    action.type === postDirectAssignSeatByAdvisorIdResponse.type ||
    action.type === postUpdateSubscriptionSeatResponse.type
  ) {
    // For invitation response, only refetch if it's not a preview (preview has 'billingPreview' property)
    if (action.type === postSeatInvitationByAdvisorIdResponse.type) {
      const payload = (action as any).payload;
      if (payload && 'billingPreview' in payload) {
        // This is a preview response, don't refetch
        return;
      }
    }
    setTimeout(() => fetchSubscriptionSeats(dispatch, getStore));
  }
}

export const invalidateSubscriptionSeatsMiddleware = createSimpleMiddleware(
  invalidateSubscriptionSeatsMiddlewareImpl,
);

function fetchSubscriptionSeats(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const state = getStore();

  const advisorId = state.session.advisor?.advisorId;

  if (!isNullOrUndefined(advisorId)) {
    dispatch(fetchSubscriptionSeatsByAdvisorIdRequest(advisorId));
  }
}

